// The league on screen's weekly hat, handed to the kit (PLAN-2026-10-30-the-
// weekly-hat §7): every team mark and character in the app reads it from
// here, the chat's cards and the League page's included, so no screen passes
// a hat along.

import { useMemo, type ReactNode } from 'react';
import { useLeagueHat } from '../data/hat';
import { HatProvider } from '../kit/hat';

export function LeagueHatScope({ children }: { children: ReactNode }) {
  const hat = useLeagueHat();
  const worn = useMemo(
    () => (hat === null ? null : { hat: hat.hat, wearers: new Set(hat.wearers) }),
    [hat],
  );
  return <HatProvider worn={worn}>{children}</HatProvider>;
}
